import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";
import {
  INITIAL_DATA_CREATE,
  tableConfigCreate,
  tableConfigNoQr,
  tableConfigQr,
} from "../config";
import {
  checkIsListGiftChange,
  constructDataDetail,
  constructQR,
  contructPayloadSubmit,
  revertCorrectionHeader,
  validateDataTable,
} from "../util";
import ReceivingInputGift from "./receivingInputGift";
import { flattenFormGroupObject } from "../../../../common/mapper";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { defaultTableChange1 } from "../../../../../modules/custom/customTable";
import InventoryPreviewQR from "../../receivingKSU/common/inventoryPreviewQR";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";

class ReceivingGiftDetail extends Component {
  constructor(props) {
    super(props);
    this.withQrTableOptions = {
      selectableRows: "multiple",
      ...defaultTableChange1(
        this.handleChangePage,
        this.handleRowsPerPage,
        this.handleOnRowSelected
      ),
    };
    this.state = {
      dataTableWithQr: [],
      dataTableNoQr: [],
      dataTable: [],
      dataTableRaw: [],
      dataHadiah: [],
      dataLocator: [],
      activeTabIndex: 0,
      activityRead: true,
      dataHeaderRaw: {},
      previewQrVisible: false,
      selectedDataQR: [],
      isCanDelete: true,
      popupApproval: {
        data: [],
        visible: false,
        isConfirmation: false,
        barcodeNeedApproval: [],
      },
      dataHadiahFiltered: [],
      pagination: {
        limit: 5, 
        page: 1,
        totalData: 0
      }
    };
  }

  componentDidMount() {
    const { initialValues } = this.props;
    this.loadDetail({ spbhNo: initialValues });
    this.loadDDL();
  }

  loadDetail = async ({ spbhNo }) => {
    const { onTriggerLoading, setError, setValue } = this.props;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailReceivingGift,
      menuName: "Receiving Gift",
      setError,
      args: {
        spbhNo: spbhNo,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const { dataNonQr, dataQr, dataDetail, dataHeader } = constructDataDetail(
        {
          data: res.data.data,
          setData: setValue,
        }
      );
      this.setState((prev) => ({
        ...prev,
        dataTableNoQr: dataNonQr,
        dataTableWithQr: dataQr,
        dataTable: dataDetail,
        dataTableRaw: dataDetail,
        dataHeaderRaw: dataHeader,
        isCanDelete: !!res.data.data?.checkDelete,
      }));
    }
  };

  handleSelectKodeHadiah = (index, name, value) => {
    this.handleSetTableValue(index, name, value);
    this.handleSetTableValue(index, "kategori", value?.categoryHadiah);
    this.handleSetTableValue(index, "namaHadiah", value?.nameHadiah);
    this.handleSetTableValue(index, "satuan", value?.satuanHadiah);
  };

  handleSetTableValue = (index, name, value) => {
    this.setState((prev) => {
      const newData = [...prev.dataTable];
      newData[index] = {
        ...newData[index],
        [name]: value,
      };
      return {
        ...prev,
        dataTable: newData,
      };
    });
  };

  handleChangeAllLocator = (value) => {
    this.setState((prev) => ({
      ...prev,
      dataTable: prev.dataTable.map((row) => {
        if (!row.saved) {
          return {
            ...row,
            locator: value,
          };
        }
        return row;
      }),
    }));
  };

  handleDeleteRow = (index) => {
    this.setState((prev) => ({
      ...prev,
      dataTable: [...prev.dataTable.filter((_, idx) => idx !== index)],
    }));
  };

  getTableConfig = (tab) => {
    if (tab === 0) {
      return tableConfigQr;
    }
    return tableConfigNoQr;
  };

  loadDDL = async () => {
    const { setError, selectedCabang, onTriggerLoading } = this.props;

    const promises = [
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllHadiah,
        menuName: "Receiving Gift",
        setError: setError,
        args: null,
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA")
          .getAllMasterLocationPagingByParam,
        menuName: "Receiving Gift",
        setError: setError,
        args: {
          paramFilters: { kodeCabang: selectedCabang?.value },
          page: null,
          limit: null,
        },
      }),
    ];

    onTriggerLoading();
    const res = await Promise.all(promises);
    onTriggerLoading();
    if (res[0].ok && res[0].data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataHadiah: res[0].data.data?.map((item) => {
          return {
            label: item.kodeHadiah,
            value: item.kodeHadiah,
            ...item,
          };
        }),
      });
    }

    if (res[1].ok && res[1].data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataLocator: res[1].data.data?.map((item) => {
          return {
            label: item.nameLocation,
            value: item.kodeLocation,
            kodeCabang: item.kodeCabang,
          };
        }),
      });
    }
  };

  handleClear = () => {
    const { resetIgnoreKeys, setValue } = this.props;
    resetIgnoreKeys(["spbhNo"]);
    setValue("spbhDate", moment().format("DD-MM-YYYY"));
    this.setState((prevState) => ({
      ...prevState,
      dataTable: [],
    }));
  };

  handleSubmit = () => {
    const { selectedCabang, controls, onSubmit } = this.props;
    const { dataTable } = this.state;
    const validateDetail = validateDataTable(dataTable);
    if (!this.props.validate() || !validateDetail) {
      this.props.onChangeAlertInfo(
        "Informasi",
        <p>
          Ada field data yang perlu diisi atau tidak sesuai kriteria isian.
          <br />
          Mohon periksa kembali
        </p>
      );
      return;
    }
    const payload = contructPayloadSubmit({
      ...flattenFormGroupObject(controls),
      kodeCabang: selectedCabang,
      dataTable,
    });
    onSubmit(payload, "update");
  };

  handleTabSelect = (index) => {
    this.setState(prev=>({
      ...prev,
      activeTabIndex: index,
      pagination:{
        limit: 5, 
        page: 1, 
        totalData: 0
      }
    }));
  };

  handleCorrection = (action) => {
    if (action === "cancel_correction") {
      this.setState((prev) => ({
        ...prev,
        activityRead: !prev.activityRead,
        dataTable: prev.dataTableRaw,
      }));
      revertCorrectionHeader(this.state.dataHeaderRaw, this.props.setValue);
      return;
    }
    this.setState((prev) => ({
      ...prev,
      activityRead: !prev.activityRead,
    }));
  };

  handleCheckQty = async (index) => {
    const selectedRow = this.state.dataTable[index];
    const originRow = this.state.dataTableRaw[index];
    if (!selectedRow) return;

    const { jumlah, locator, kodeHadiah } = selectedRow;
    const isQtyChanged = Number(jumlah) !== Number(originRow?.jumlah);

    if (!isQtyChanged) {
      return this.handleSetTableValue(index, "saved", true);
    }

    try {
      this.props.onTriggerLoading();
      const payload = {
        kodeCabang: locator?.kodeCabang,
        idLocator: locator?.value,
        giftCode: kodeHadiah?.value,
        prevTotal: Number(originRow?.jumlah),
        newTotal: Number(jumlah),
      };

      const response = await Api.create("NAGAMAS_TRANSACTION").checkQtyGift(
        payload
      );
      this.props.onTriggerLoading();

      if (response.ok) {
        this.handleSetTableValue(index, "saved", true);
      } else {
        this.props.onChangeAlertInfo("Informasi", response.data?.message);
      }
    } catch (error) {
      this.props.onTriggerLoading();
      console.error("checkQty error:", error);
    }
  };

  getTableConfigCorrection = () => {
    const { dataHadiah, dataLocator, dataTable, dataHadiahFiltered } =
      this.state;
    return tableConfigCreate({
      dataHadiah:
        dataHadiahFiltered.length > 0 ? dataHadiahFiltered : dataHadiah,
      onKodeHadiahChange: this.handleSelectKodeHadiah,
      dataLocator: dataTable.length > 0 ? dataLocator : [],
      onChangeAllLocator: this.handleChangeAllLocator,
      onDeleteRow: this.handleDeleteRow,
      onTableValueChange: this.handleSetTableValue,
      onSaveRow: this.handleCheckQty,
      dataTable: dataTable,
      openKodeHadiah: this.handleOpenKodeHadiah,
    });
  };

  handleSubmitCorrection = () => {
    const { selectedCabang, controls, onSubmit } = this.props;
    const { dataTable } = this.state;
    const payload = contructPayloadSubmit({
      ...flattenFormGroupObject(controls),
      kodeCabang: selectedCabang,
      dataTable,
    });

    onSubmit(payload, "update");
  };

  handleAddRow = (tab) => {
    this.setState((prevValue) => ({
      ...prevValue,
      dataTable: [...prevValue.dataTable, INITIAL_DATA_CREATE],
    }));
  };

  handleOpenKodeHadiah = () => {
    this.setState((prev) => ({
      ...prev,
      dataHadiahFiltered: prev?.dataHadiah?.filter(
        (item) =>
          !prev?.dataTable
            ?.map((item) => item.kodeHadiah?.value)
            ?.includes(item.value)
      ),
    }));
  };

  handleSubmitCheck = () => {
    const { dataTable, dataTableRaw } = this.state;
    const validateDetail = validateDataTable(dataTable);
    if (!this.props.validate() || !validateDetail) {
      this.props.onChangeAlertInfo(
        "Informasi",
        <p>
          Ada field data yang perlu diisi atau tidak sesuai kriteria isian.
          <br />
          Mohon periksa kembali
        </p>
      );
      return;
    }
    if (checkIsListGiftChange(dataTableRaw, dataTable)) {
      const { selectedCabang, controls } = this.props;
      const payload = contructPayloadSubmit({
        ...flattenFormGroupObject(controls),
        kodeCabang: selectedCabang,
        dataTable,
      });

      return this.props.onChangeAlertInfo(
        "Informasi",
        <div>
          <p>Perubahan jumlah akan men-generate QR Code Item baru.</p>
          <p>Apakah Anda yakin mau merubah nilai jumlah di tabel ini?</p>
        </div>,
        payload,
        "update"
      );
    }
    this.handleSubmitCorrection();
  };

  fetchUpdateNumberOfPrintQRCode = async () => {
    try {
      let reqBody = this.state.selectedDataQR.map((item) => item.giftBarcode);
      await Api.create("NAGAMAS_TRANSACTION").updateNumberOfPrintsReceivingGift(
        reqBody
      );
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchGenerateQRCode = async () => {
    try {
      let reqBody = constructQR(this.state.selectedDataQR);
      let res = await Api.create("NAGAMAS_REPORT").generateQRReceivingUnitKSU(
        reqBody
      );
      if (res.ok) {
        if (reqBody.length > 0) {
          await this.fetchUpdateNumberOfPrintQRCode();
          this.setState((prevState) => ({
            ...prevState,
            previewQrVisible: true,
            PDF: URL.createObjectURL(res.data),
          }));
        }
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  validateQRCodePrintApproval = async () => {
    const userId = localStorage.getItem("userId");
    const { selectedDataQR } = this.state;
    const { controls, selectedCabang } = this.props;
    const payload = {
      trxId: controls.spbhNo.value,
      kodeCabang: selectedCabang?.value,
      idUserPemohon: userId,
      module: "RECEIVING_HADIAH",
      listBarcode: selectedDataQR?.map((item) => item.giftBarcode),
    };
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").checkPrintQRKSUApproval,
      menuName: "Receiving Gift",
      setError: this.props.setError,
      args: payload,
    });

    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      const { listBarcodeToPrint, listBarcodeNeedApproval, listIdRequest } =
        response.data.data;
      if (listBarcodeToPrint) {
        await this.fetchGenerateQRCode();
      } else {
        this.handlePopupAlertVisibility(
          listBarcodeNeedApproval || listIdRequest,
          listBarcodeNeedApproval
        );
      }
    }
  };

  createApprovalQRPrint = async () => {
    const { controls, selectedCabang, onTriggerLoading, setError } = this.props;
    const { popupApproval } = this.state;
    const userId = localStorage.getItem("userId");

    onTriggerLoading();

    const payload = {
      trxId: controls.spbhNo.value,
      kodeCabang: selectedCabang?.value,
      idUserPemohon: userId,
      module: "RECEIVING_HADIAH",
      listBarcode: popupApproval?.barcodeNeedApproval || [],
    };
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").createApprovalPrint,
      menuName: "Receiving Unit - KSU",
      setError: setError,
      args: payload,
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handlePreviewQrVisibility("close");
      this.handlePopupAlertVisibility();
    }
  };

  handlePopupAlertVisibility = (data, barcodeNeedApproval) => {
    this.setState((prev) => ({
      popupApproval: {
        data: data || [],
        visible: !prev.popupApproval.visible,
        isConfirmation: Boolean(barcodeNeedApproval),
        barcodeNeedApproval: barcodeNeedApproval || [],
      },
    }));
  };

  handlePreviewQrVisibility = async (action) => {
    const { onTriggerLoading, onChangeAlertInfo } = this.props;
    const { selectedDataQR } = this.state;

    onTriggerLoading();
    if (action === "generate") {
      if (!selectedDataQR || selectedDataQR.length === 0) {
        onTriggerLoading();
        return onChangeAlertInfo(
          "PERINGATAN",
          "Data belum di ceklis, harap pilih data terlebih dahulu untuk dicetak."
        );
      }
      await this.validateQRCodePrintApproval();
    }

    if (action === "close") {
      const { initialValues } = this.props;
      await this.loadDetail({ spbhNo: initialValues });
      this.setState((prevValue) => ({
        ...prevValue,
        selectedDataQR: [],
        previewQrVisible: false,
      }));
    }
    onTriggerLoading();
  };

  handleOnRowSelected = (listIndex) => {
    const selectedData = listIndex.map(
      (index) => this.state.dataTableWithQr[index]
    );
    this.setState((prevState) => ({
      ...prevState,
      selectedDataQR: selectedData,
    }));
  };

  handleStateChange = (callback) => {
    this.setState(callback);
  };

  handleDeleteData = () => {
    this.props.onChangeAlertInfo(
      "Peringatan",
      "Anda yakin hendak menghapus data pada tabel ini?",
      this.props.initialValues,
      "delete"
    );
  };

  renderAlertApproval = () => {
    const { popupApproval } = this.state;
    const isConfirmation = popupApproval.isConfirmation;
    const title = isConfirmation ? "Konfirmasi" : "Informasi";
    const subTitle = isConfirmation
      ? "Cetak ulang QR dengan no QR:"
      : "Pengajuan tidak dapat dilakukan sebelum pengajuan dengan No. Request: ";
    const desc = isConfirmation
      ? "Apakah anda yakin?"
      : "dilakukan keputusan APPROVE/REJECT";
    return (
      <SimpleAlert
        title={title}
        visible={popupApproval.visible}
        onClickClose={() => this.handlePopupAlertVisibility()}
        content={
          <div style={{ textAlign: "left" }}>
            <p style={{ marginBottom: "10px" }}>{subTitle}</p>
            <FlexView
              style={{ gap: "10px", maxHeight: "200px", overflowY: "auto" }}
            >
              <ul
                style={{
                  listStyleType: "circle",
                  paddingLeft: "20px",
                }}
              >
                {popupApproval.data.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </FlexView>
            <p style={{ marginTop: "10px" }}>{desc}</p>
          </div>
        }
        additionalButtons={
          isConfirmation ? (
            <FlexView vAlignContent="center" style={{ gap: "10px" }}>
              <SimpleButton onClick={() => this.handlePopupAlertVisibility()}>
                TIDAK
              </SimpleButton>
              <SimpleButton onClick={this.createApprovalQRPrint}>
                YA
              </SimpleButton>
            </FlexView>
          ) : (
            <SimpleButton onClick={() => this.handlePopupAlertVisibility()}>
              OK
            </SimpleButton>
          )
        }
      />
    );
  };

  handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

  render() {
    const { visible, onClickClose, userAccess } = this.props;
    const {
      dataTableWithQr,
      dataTableNoQr,
      activityRead,
      activeTabIndex,
      dataTable,
      previewQrVisible,
      PDF,
      selectedDataQR,
      isCanDelete,
    } = this.state;
    const isQrTabReadOnly = activeTabIndex === 0 && activityRead;
    return (
      <React.Fragment>
        <SimpleModal
          title="Tambah Penerimaan Hadiah"
          visible={visible}
          styles={{ width: "80%" }}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <ReceivingInputGift {...this.props} activityRead={activityRead} />
              {activityRead ? (
                <React.Fragment>
                  <FlexView
                    vAlignContent="center"
                    style={{ justifyContent: "space-between" }}
                  >
                    <h3 className="margin-bottom-10px">
                      Detail Penerimaan Hadiah :
                    </h3>
                    <h4 className="margin-bottom-10px">
                      Jumlah Data:{" "}
                      {activeTabIndex === 0
                        ? dataTableWithQr?.length
                        : dataTableNoQr?.length}
                    </h4>
                  </FlexView>

                  <Tabs
                    selectedIndex={activeTabIndex}
                    onSelect={this.handleTabSelect}
                  >
                    <TabList>
                      <Tab>Dengan QR</Tab>
                      <Tab>Tanpa QR</Tab>
                    </TabList>
                    <TabPanel>
                      <SimpleDataTable
                        key={`${dataTableWithQr.length}-${this.state.pagination.page}`}
                        data={dataTableWithQr}
                        columns={this.getTableConfig(0)}
                        options={{...this.withQrTableOptions, serverSide: false,}}
                        toCount={dataTableWithQr.length}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                      />
                    </TabPanel>
                    <TabPanel>
                      <SimpleDataTable
                        key={`${dataTableNoQr.length}-${this.state.pagination.page}`}
                        data={dataTableNoQr}
                        columns={this.getTableConfig(1)}
                        options={{...this.withQrTableOptions, serverSide: false,}}
                        toCount={dataTableNoQr.length}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                      />
                    </TabPanel>
                  </Tabs>
                </React.Fragment>
              ) : (
                <>
                  <FlexView
                    vAlignContent="center"
                    className="margin-bottom-10px"
                  >
                    <h4 className="margin-right-10px">Hadiah :</h4>
                    <SimpleButton
                      className={"btn btn-plus background-red margin-left-10px"}
                      onClick={this.handleAddRow}
                      style={{ width: 145 }}
                      icon={<i className="fa fa-plus margin-right-10px"></i>}
                      text={"Tambah Barang"}
                    />
                  </FlexView>
                  <SimpleDataTable
                    key={`${dataTable.length}-${this.state.pagination.page}`}
                    data={dataTable}
                    columns={this.getTableConfigCorrection()}
                    options={{...this.withQrTableOptions, serverSide: false,}}
                    toCount={dataTable.length}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                  />
                </>
              )}
              <FlexView
                className="margin-top-10px"
                style={{
                  justifyContent: isQrTabReadOnly
                    ? "space-between"
                    : "flex-end",
                }}
              >
                {activeTabIndex === 0 && activityRead && (
                  <SimpleButton
                    className="margin-left-none"
                    text={"Print QR"}
                    onClick={() => this.handlePreviewQrVisibility("generate")}
                  />
                )}
                {activityRead ? (
                  <FlexView vAlignContent="bottom">
                    {userAccess && userAccess.updateAccess && (
                      <SimpleButton
                        type="button"
                        text="Koreksi"
                        onClick={() => this.handleCorrection("correction")}
                      />
                    )}
                    {userAccess && userAccess.deleteAccess && isCanDelete && (
                      <SimpleButton
                        type="button"
                        text="Hapus"
                        onClick={this.handleDeleteData}
                      />
                    )}
                    <SimpleButton
                      type="button"
                      text="Keluar"
                      onClick={() => onClickClose()}
                    />
                  </FlexView>
                ) : (
                  <FlexView vAlignContent="bottom">
                    <SimpleButton
                      type="button"
                      text="Clear"
                      onClick={this.handleClear}
                    />
                    <SimpleButton
                      type="button"
                      text="Simpan"
                      onClick={this.handleSubmitCheck}
                    />
                    <SimpleButton
                      type="button"
                      text="Batal"
                      onClick={() => this.handleCorrection("cancel_correction")}
                    />
                  </FlexView>
                )}
              </FlexView>
              {previewQrVisible && (
                <InventoryPreviewQR
                  PDF={PDF}
                  visible={previewQrVisible}
                  onPreviewQr={() => this.handlePreviewQrVisibility("close")}
                  onStateChange={this.handleStateChange}
                />
              )}
            </ModalContainer>
          }
        />
        {this.renderAlertApproval()}
      </React.Fragment>
    );
  }
}

export default withFormGroup(ReceivingGiftDetail);
